import { SHA256 } from 'crypto-js';

export const generateCodeChallenge = (codeVerifier: string): string => SHA256(codeVerifier).toString();
